import React, { useContext } from 'react';
import propTypes from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { Route, Routes, ScrollToTop } from '@thd-olt-component-react/router';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { Error } from './pages';
import { getRoutes } from './routes';

import './styles/app.scss';

const { arrayOf, shape } = propTypes;

export const App = ({ serverPages }) => {
  const { instance } = useContext(AppContext);

  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;

  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <ContentfulLivePreviewProvider locale="en-US" targetOrigin="https://app.contentful.com">
      <ScrollToTop />
      <Routes>
        <Route exact path={routes.landingA.path} element={<routes.landingA.component />} />
        <Route exact path={routes.landingB.path} element={<routes.landingB.component />} />
        <Route exact path={routes.landingC.path} element={<routes.landingC.component />} />
        <Route exact path={routes.landingTest.path} element={<routes.landingTest.component />} />
        {/* <Route exact path={routes.home.path} element={<routes.home.component />} /> */}
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </ContentfulLivePreviewProvider>
  );
};

App.propTypes = {
  serverPages: arrayOf(shape({}))
};

App.defaultProps = {};
